import React from 'react'
import './footer.css'

const MyFooter = () => {
  return (
    <div className="footerer">
      <div className="container-footer mx-auto flex max-w-[1180px] flex-col px-[20px] xl:px-0">
        <div className="grid grid-cols-12 gap-4 ">
          <div className="col-span-12 md:col-span-4 lg:col-span-3">
            <div className="flex">
              <span className="px-2 py-1 bg-gradient-to-r from-red-500 via-amber-700 to-yellow-500 rounded-lg text-white text-xl font-semibold">
                Cognipath
              </span>
            </div>
            <div className="footerer-h2 pb-3 pt-3  md:pt-10 ">
              Download the app now
            </div>
            <a href="">
              <svg
                width="171"
                height="60"
                viewBox="0 0 171 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="170.087" height="60" rx="8" fill="white"></rect>
                <g clip-path="url(#clip0_1363_76620)">
                  <path
                    d="M42.9358 26.8603C40.6125 25.5608 36.8834 23.4741 31.0993 20.2355C30.7094 19.9779 30.2607 19.9442 29.873 20.0754L39.7969 29.9993L42.9358 26.8603Z"
                    fill="#32BBFF"
                  ></path>
                  <path
                    d="M29.8736 20.0754C29.8009 20.1 29.7302 20.1297 29.6626 20.1655C29.2345 20.3971 28.9199 20.8427 28.9199 21.4062V38.5922C28.9199 39.1558 29.2345 39.6014 29.6626 39.8329C29.7301 39.8687 29.8007 39.8985 29.8733 39.9233L39.7974 29.9992L29.8736 20.0754Z"
                    fill="#32BBFF"
                  ></path>
                  <path
                    d="M39.7971 29.9993L29.873 39.9233C30.2608 40.0555 30.7095 40.0243 31.0996 39.763C36.7089 36.622 40.3959 34.5601 42.7462 33.2495C42.8116 33.2128 42.8757 33.1768 42.939 33.1412L39.7971 29.9993Z"
                    fill="#32BBFF"
                  ></path>
                  <path
                    d="M28.9199 29.9993V38.5923C28.9199 39.1558 29.2345 39.6014 29.6626 39.8329C29.7301 39.8687 29.8007 39.8985 29.8733 39.9233L39.7974 29.9993H28.9199Z"
                    fill="#2C9FD9"
                  ></path>
                  <path
                    d="M31.0994 20.2355C30.6363 19.9297 30.0902 19.9384 29.6621 20.1656L39.6463 30.1498L42.9358 26.8603C40.6125 25.5608 36.8835 23.4741 31.0994 20.2355Z"
                    fill="#29CC5E"
                  ></path>
                  <path
                    d="M39.6464 29.8487L29.6621 39.8329C30.0902 40.06 30.6363 40.0732 31.0994 39.763C36.7087 36.622 40.3957 34.56 42.746 33.2495C42.8114 33.2127 42.8755 33.1768 42.9389 33.1412L39.6464 29.8487Z"
                    fill="#D93F21"
                  ></path>
                  <path
                    d="M47.08 29.9993C47.08 29.5231 46.8397 29.0425 46.3635 28.7761C46.3635 28.7761 45.4729 28.2791 42.7431 26.7523L39.4961 29.9993L42.7463 33.2495C45.4461 31.7336 46.3634 31.2224 46.3634 31.2224C46.8397 30.956 47.08 30.4754 47.08 29.9993Z"
                    fill="#FFD500"
                  ></path>
                  <path
                    d="M46.3635 31.2225C46.8397 30.956 47.08 30.4754 47.08 29.9993H39.4961L42.7463 33.2495C45.4461 31.7336 46.3635 31.2225 46.3635 31.2225Z"
                    fill="#FFAA00"
                  ></path>
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M90.7493 37.9349C90.2168 37.5089 89.7907 36.7633 89.5777 36.3373L91.2819 35.5917C91.3884 35.8047 91.6014 36.1243 91.8144 36.4438C92.2405 36.8698 92.8795 37.2959 93.5186 37.2959C94.1576 37.2959 94.9032 36.9763 95.3292 36.4438C95.6487 35.9112 95.8617 35.3787 95.8617 34.6331V33.9941C94.5836 35.5917 91.9209 35.3787 90.4298 33.6746C88.8321 31.9704 88.8321 29.0947 90.4298 27.3905C92.0274 25.7929 94.3706 25.5799 95.7552 27.071V26.3254H97.5659V34.3136C97.5659 36.3373 96.8203 37.5089 95.8617 38.2544C95.2227 38.787 94.2641 39 93.4121 39C92.4535 38.8935 91.4949 38.574 90.7493 37.9349ZM135.377 38.3609L137.187 34.1006L133.992 26.7515H135.803L138.039 31.9704L140.276 26.7515H142.087L137.187 38.3609H135.377ZM126.749 34.3136C126.217 33.7811 126.004 33.0355 126.004 32.2899C126.004 31.6509 126.217 31.0118 126.643 30.5858C127.388 29.8402 128.453 29.5207 129.625 29.5207C130.371 29.5207 131.01 29.6272 131.542 29.9467C131.542 28.6686 130.477 28.1361 129.625 28.1361C128.88 28.1361 128.134 28.5621 127.814 29.3077L126.217 28.6686C126.536 27.9231 127.388 26.5385 129.519 26.5385C130.584 26.5385 131.649 26.858 132.288 27.6036C132.927 28.3491 133.14 29.2012 133.14 30.3728V34.8462H131.329V34.1006C131.116 34.4201 130.69 34.6331 130.371 34.8462C129.945 35.0592 129.412 35.1657 128.879 35.1657C128.24 35.0592 127.282 34.8462 126.749 34.3136ZM69.9801 30.4793C69.9801 28.3491 71.5777 26.0059 74.4535 26.0059C77.2227 26.0059 78.9268 28.3491 78.9268 30.4793C78.9268 32.6095 77.3292 34.9527 74.4535 34.9527C71.5777 34.9527 69.9801 32.6095 69.9801 30.4793ZM79.5659 30.4793C79.5659 28.3491 81.1635 26.0059 84.0393 26.0059C86.8085 26.0059 88.5126 28.3491 88.5126 30.4793C88.5126 32.6095 86.915 34.9527 84.0393 34.9527C81.27 34.9527 79.5659 32.6095 79.5659 30.4793ZM57.9446 32.8225C55.2819 30.1598 55.3884 25.7929 58.0511 23.0237C59.4357 21.6391 61.1399 21 62.9505 21C64.6546 21 66.3588 21.6391 67.6369 22.9172L66.3588 24.3018C64.4416 22.3846 61.3529 22.4911 59.5422 24.4083C57.6251 26.432 57.6251 29.5207 59.5422 31.5444C61.4594 33.568 64.6546 33.6746 66.5718 31.6509C67.2109 31.0118 67.4239 30.1598 67.5304 29.3077H63.057V27.3905H69.341C69.4475 27.8166 69.4476 28.3491 69.4476 28.8817C69.4476 30.4793 68.8085 32.0769 67.7434 33.142C66.5718 34.3136 64.8677 34.9527 63.1635 34.9527C61.2464 34.8462 59.3292 34.2071 57.9446 32.8225ZM102.998 33.568C101.4 31.8639 101.4 28.9882 102.998 27.1775C104.595 25.4734 107.258 25.4734 108.749 27.1775C109.282 27.7101 109.601 28.4556 109.921 29.2012L104.063 31.6509C104.382 32.3964 105.128 33.0355 106.193 33.0355C107.152 33.0355 107.791 32.716 108.43 31.7574L110.027 32.8225C109.814 33.0355 109.601 33.2485 109.495 33.4615C107.684 35.2722 104.595 35.2722 102.998 33.568ZM114.075 34.8462V23.0237H117.909C120.146 23.0237 121.956 24.6213 121.956 26.5385C121.956 28.4556 120.359 30.0533 118.335 30.0533H115.992V34.7396H114.075V34.8462ZM123.022 34.8462V23.0237H124.832V34.8462H123.022ZM98.9505 34.6331V21.426H100.868V34.6331H98.9505ZM131.436 31.3314C131.01 31.0118 130.371 30.9053 129.732 30.9053C128.453 30.9053 127.708 31.5444 127.708 32.2899C127.708 33.0355 128.453 33.4615 129.199 33.4615C130.264 33.4615 131.436 32.6095 131.436 31.3314ZM76.9032 30.4793C76.9032 29.2012 76.0511 27.8166 74.4535 27.8166C72.8558 27.8166 72.0038 29.2012 72.0038 30.4793C72.0038 31.7574 72.8558 33.142 74.4535 33.142C75.9446 33.142 76.9032 31.7574 76.9032 30.4793ZM86.489 30.4793C86.489 29.2012 85.6369 27.8166 84.0393 27.8166C82.4416 27.8166 81.5896 29.2012 81.5896 30.4793C81.5896 31.7574 82.4416 33.142 84.0393 33.142C85.6369 33.142 86.489 31.7574 86.489 30.4793ZM95.9683 31.2248C95.9683 31.1183 95.9683 31.0118 96.0748 30.9053C96.0748 30.7988 96.0748 30.5858 96.0748 30.4793C96.0748 30.3728 96.0748 30.1598 96.0748 30.0533V29.9467C96.0748 29.8402 95.9683 29.6272 95.9683 29.5207C95.6487 28.4556 94.6901 27.7101 93.7316 27.7101C92.4535 27.7101 91.3884 28.9882 91.3884 30.3728C91.3884 31.8639 92.4535 33.0355 93.8381 33.0355C94.6902 33.142 95.5422 32.3964 95.9683 31.2248ZM103.743 30.2663L107.684 28.5621C107.258 27.8166 106.619 27.6036 106.087 27.6036C104.489 27.7101 103.53 29.4142 103.743 30.2663ZM120.039 26.645C120.039 25.5799 119.187 24.8343 118.016 24.8343H115.885V28.5621H118.122C119.187 28.5621 120.039 27.7101 120.039 26.645Z"
                  fill="#232C6A"
                ></path>
                <defs>
                  <clipPath id="clip0_1363_76620">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(28 20)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
            <h3 className=" footerer-h3 pt-3 font-medium md:pt-10 ">
              Connect with us
            </h3>
            <div class="social-icons grid grid-cols-4 ">
              <a
                href="https://www.facebook.com/shikho.bangladesh/"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="54"
                  height="50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="-0.001"
                    width="54"
                    height="50"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <path
                    d="M23.905 26.675h-3.222c-.52 0-.683-.195-.683-.684v-3.937c0-.52.195-.683.683-.683h3.222v-2.864c0-1.302.228-2.538.878-3.677.684-1.171 1.66-1.952 2.897-2.408A7.239 7.239 0 0130.185 12h3.19c.455 0 .65.195.65.65v3.71c0 .456-.195.651-.65.651-.88 0-1.758 0-2.637.033-.878 0-1.334.423-1.334 1.334-.032.976 0 1.92 0 2.929h3.775c.52 0 .716.195.716.716v3.937c0 .52-.163.683-.716.683h-3.775v10.609c0 .553-.163.748-.748.748h-4.068c-.488 0-.683-.195-.683-.683V26.675z"
                    fill="#1777F2"
                  ></path>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/channel/UCYfTpKVP5YQ7t7p6_eJhSEQ"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="54"
                  height="50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="-0.001"
                    width="54"
                    height="50"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <path fill="#fff" d="M21 18.999h12v13H21z"></path>
                  <g filter="url(#youtube_svg__filter0_d_25:2476)">
                    <path
                      d="M40.423 18.972c-.323-1.163-1.268-2.079-2.468-2.392C35.765 16 27 16 27 16s-8.765 0-10.956.559c-1.176.313-2.145 1.252-2.467 2.414C13 21.095 13 25.5 13 25.5s0 4.426.577 6.527c.323 1.162 1.268 2.079 2.468 2.392 2.214.581 10.955.581 10.955.581s8.764 0 10.955-.559c1.2-.313 2.145-1.23 2.468-2.392.577-2.123.577-6.527.577-6.527s.023-4.426-.577-6.549zM24.21 29.567v-8.136l7.288 4.068-7.288 4.068z"
                      fill="#FE0000"
                    ></path>
                  </g>
                  <defs>
                    <filter
                      id="youtube_svg__filter0_d_25:2476"
                      x="11"
                      y="13.999"
                      width="32"
                      height="23"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      ></feFlood>
                      <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      ></feColorMatrix>
                      <feOffset></feOffset>
                      <feGaussianBlur stdDeviation="1"></feGaussianBlur>
                      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                      <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_25:2476"
                      ></feBlend>
                      <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_25:2476"
                        result="shape"
                      ></feBlend>
                    </filter>
                  </defs>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/shikho.edtech/"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="54"
                  height="50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="-0.001"
                    width="54"
                    height="50"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <path
                    d="M26.499 30.647a5.147 5.147 0 100-10.294 5.147 5.147 0 000 10.294z"
                    fill="url(#instagram_svg__paint0_linear_25:2481)"
                  ></path>
                  <path
                    d="M32.719 13.064c-3.1-.087-9.303-.087-12.402 0-1.613.044-3.441.451-4.59 1.695-1.194 1.293-1.646 2.855-1.691 4.603-.08 3.068 0 12.274 0 12.274.052 1.747.497 3.31 1.69 4.603 1.15 1.244 2.978 1.65 4.591 1.695 3.1.087 9.302.087 12.402 0 1.612-.044 3.44-.451 4.59-1.695 1.194-1.293 1.645-2.855 1.691-4.603V19.362c-.046-1.747-.497-3.31-1.691-4.603-1.15-1.244-2.978-1.65-4.59-1.695zm-6.202 20.605a7.985 7.985 0 01-4.478-1.377 8.148 8.148 0 01-2.969-3.667 8.273 8.273 0 01-.459-4.72 8.205 8.205 0 012.206-4.183 8.028 8.028 0 014.128-2.236 7.961 7.961 0 014.657.465 8.085 8.085 0 013.618 3.01 8.248 8.248 0 011.358 4.538c0 2.167-.849 4.245-2.36 5.777a8.007 8.007 0 01-5.7 2.393zm8.096-14.653c-.319 0-.63-.096-.896-.276a1.63 1.63 0 01-.593-.733 1.655 1.655 0 01.35-1.78 1.593 1.593 0 011.757-.354c.294.123.546.332.723.6a1.65 1.65 0 01-.2 2.064 1.611 1.611 0 01-1.141.479z"
                    fill="url(#instagram_svg__paint1_linear_25:2481)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="instagram_svg__paint0_linear_25:2481"
                      x1="22.043"
                      y1="29.977"
                      x2="31.581"
                      y2="21.72"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FD5"></stop>
                      <stop offset="0.5" stop-color="#FF543E"></stop>
                      <stop offset="1" stop-color="#C837AB"></stop>
                    </linearGradient>
                    <linearGradient
                      id="instagram_svg__paint1_linear_25:2481"
                      x1="14"
                      y1="37.999"
                      x2="38.95"
                      y2="16.446"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FD5"></stop>
                      <stop offset="0.5" stop-color="#FF543E"></stop>
                      <stop offset="1" stop-color="#C837AB"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/shikho/"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="54"
                  height="50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="-0.001"
                    width="54"
                    height="50"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <path
                    d="M14.853 36.998h3.416a.853.853 0 00.853-.853V21.216a.853.853 0 00-.853-.853h-3.416a.853.853 0 00-.853.853v14.93c0 .47.382.852.853.852zM14.853 17.738h3.416a.853.853 0 00.853-.853v-3.033a.853.853 0 00-.853-.853h-3.416a.853.853 0 00-.853.853v3.033c0 .471.382.853.853.853zM38.988 22.095c-.48-.631-1.188-1.151-2.124-1.558-.935-.407-1.968-.61-3.098-.61-2.295 0-4.238.875-5.832 2.626-.317.349-.548.273-.548-.199v-1.137a.853.853 0 00-.853-.853h-3.051a.853.853 0 00-.853.853v14.929c0 .47.382.853.853.853h3.416a.853.853 0 00.853-.853v-5.192c0-2.163.13-3.646.391-4.448a3.673 3.673 0 011.45-1.931c.704-.487 1.5-.73 2.387-.73.693 0 1.285.17 1.778.51.492.341.847.818 1.066 1.431.219.614.328 1.966.328 4.056v6.304c0 .47.382.853.853.853h3.416a.853.853 0 00.853-.853V27.69c0-1.494-.095-2.643-.283-3.445a5.642 5.642 0 00-1.002-2.15z"
                    fill="#2567B3"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 md:ml-6 lg:col-span-3 gap-5">
            <h2 className="footerer-link-h2">Link</h2>
            <ul className="gap-y-10">
              <li className="footerer-link-a gap-y-4" href="">
                <a>Home</a>
              </li>
              <li className="footerer-link-a gap-y-4" href="/about">
                <a>About Us</a>
              </li>
              <li
                className="footerer-link-a gap-y-4"
                href="https://shikho.freshteam.com/jobs"
              >
                <a>Career</a>
              </li>
              <li
                className="footerer-link-a gap-y-4"
                href="https://bohubrihi.com/"
              >
                <a>Skills</a>
              </li>
            </ul>
          </div>
          <div className="col-span-12 md:col-span-4 lg:col-span-3">
            <h2 className="footerer-link-h2">Connect</h2>
            <ul className="flex flex-col gap-4">
              <li className="flex flex-row items-center gap-4">
                <svg
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="cursor-pointer"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                >
                  <rect width="40" height="40" rx="8" fill="#E0F1FE"></rect>
                  <g clip-path="url(#clip0_1363_76659)">
                    <path
                      d="M29.4561 24.678L26.6651 21.8869C25.6683 20.8901 23.9737 21.2889 23.575 22.5847C23.2759 23.4819 22.2791 23.9803 21.382 23.7809C19.3884 23.2825 16.697 20.6908 16.1986 18.5975C15.8996 17.7003 16.4976 16.7035 17.3948 16.4045C18.6906 16.0058 19.0893 14.3112 18.0925 13.3144L15.3015 10.5233C14.504 9.82556 13.3079 9.82556 12.6101 10.5233L10.7162 12.4173C8.82223 14.4109 10.9155 19.6939 15.6005 24.3789C20.2855 29.0639 25.5686 31.2569 27.5622 29.2633L29.4561 27.3694C30.1539 26.5719 30.1539 25.3757 29.4561 24.678Z"
                      fill="#3DAFFD"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1363_76659">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(10 10)"
                      ></rect>
                    </clipPath>
                  </defs>
                </svg>
                <span className="footerer-company-details cursor-pointer">
                  0193128334512
                </span>
              </li>
              <li className="flex flex-row items-center gap-4">
                <svg
                  className="cursor-pointer"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="40" height="40" rx="8" fill="#E9EBF9"></rect>
                  <path
                    d="M20.5785 22.5266C20.3896 22.6447 20.1771 22.6919 19.9882 22.6919C19.7993 22.6919 19.5868 22.6447 19.3979 22.5266L10 16.7887V24.4156C10 26.0449 11.3223 27.3672 12.9516 27.3672H27.0484C28.6777 27.3672 30 26.0449 30 24.4156V16.7887L20.5785 22.5266Z"
                    fill="#4353CC"
                  ></path>
                  <path
                    d="M27.0477 12.6328H12.9509C11.5577 12.6328 10.3771 13.6245 10.0938 14.9469L20.0111 20.9917L29.9048 14.9469C29.6215 13.6245 28.4409 12.6328 27.0477 12.6328Z"
                    fill="#4353CC"
                  ></path>
                </svg>
                <span className="footerer-company-details cursor-pointer">
                  team@promiseinfotech.com
                </span>
              </li>
              <li className="flex flex-row items-center gap-4">
                <svg
                  className=" cursor-pointer"
                  width="60"
                  height="60"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="40" height="40" rx="8" fill="#E0F4F2"></rect>
                  <path
                    d="M19.9991 10C16.0052 10 12.7559 13.2493 12.7559 17.2432C12.7559 22.1998 19.2379 29.4763 19.5138 29.7836C19.773 30.0723 20.2256 30.0718 20.4844 29.7836C20.7604 29.4763 27.2423 22.1998 27.2423 17.2432C27.2423 13.2493 23.993 10 19.9991 10ZM19.9991 20.8875C17.9896 20.8875 16.3549 19.2527 16.3549 17.2432C16.3549 15.2338 17.9897 13.599 19.9991 13.599C22.0085 13.599 23.6433 15.2338 23.6433 17.2432C23.6433 19.2527 22.0085 20.8875 19.9991 20.8875Z"
                    fill="#00B19E"
                  ></path>
                </svg>
                <a
                  target="_blank"
                  className="footerer-company-details cursor-pointer"
                  href="https://goo.gl/maps/Av6mVjuTmbmchuXd8"
                >
                  Khaja Super Market, 2 <sup>nd</sup> to 7<sup>th</sup> Floor,
                  Kallyanpur Bus Stop, Mirpur Road, Dhaka-1207.
                </a>
              </li>
            </ul>
          </div>
          <div class="col-span-12 md:col-span-4 lg:col-span-3">
            <h2 class="footerer-link-h2">Company Info</h2>
            <div class="flex flex-col">
              <p class="footerer-company-details">Trade licence No:</p>
              <p class="footerer-company-details">TRAD/DNCC/037245/2022</p>
              <p class="footerer-company-details pt-4">
                E-TIN Number : 197682866359
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyFooter
